import React from 'react';
import iconOne from '../assets/images/one-ic.svg';
import iconTwo from '../assets/images/two-ic.svg';
import iconTrello from '../assets/images/trello.webp';
import iconIllustrator from '../assets/images/illustrator.png';
import iconClickup from '../assets/images/clickup.png';
import iconGsuite from '../assets/images/gsuite.png';



function Resume() {
    const containerStyle = {
        textAlign: 'center',
        marginBottom: '20px'
    };

    const iconsContainerStyle = {
        textAlign: 'center',
        marginTop: '40px'
    };

    return (
        <article className="content active" data-page="resume">
            <header>
                <h2 className="h2 article-title">Educación</h2>
            </header>
            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconOne} alt="icono uno" width="40" />
                    </div>
                    <h3 className="h3">Formación Académica</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">
                            2022-2023.- Máster en Comunicación en Industrias Creativas
                        </h4>
                        <span>Universidad de Alicante</span>
                    </li>
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">
                            2015-2019.- Licenciatura en Negocios de la Moda
                        </h4>
                        <span>Universidad Autónoma de Guadalajara</span>
                    </li>
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">
                            2017-2018.- Diplomado en Imagen para Caballero
                        </h4>
                        <span>Universidad Autónoma de Guadalajara</span>
                    </li>
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">
                            2016-2017.- Certificado en Presencia ejecutiva, Desarrollo de Imagen y
                            Análisis personalizado de Color
                        </h4>
                        <span>Styleinnovators</span>
                    </li>
                </ol>
            </section>

            <section className="timeline">
                <div className="title-wrapper">
                    <div className="icon-box">
                        <img src={iconTwo} alt="icono dos" width="40" />
                    </div>
                    <h3 className="h3">Idiomas</h3>
                </div>
                <ol className="timeline-list">
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">
                            Español
                        </h4>
                        <span>Nativo</span>
                    </li>
                    <li className="timeline-item">
                        <h4 className="h4 timeline-item-title">
                            Inglés
                        </h4>
                        <span>Avanzado</span>
                    </li>
                </ol>
            </section>

            <section className="skill">
                <h3 className="h3 skills-title">Conocimientos</h3>
                <div style={iconsContainerStyle}>
                    <ul className="skills-list content-card">
                        <li>
                            <img src={iconIllustrator} alt="icono Ilustrador" width="40" />
                        </li>
                        <li>
                            <img src={iconTrello} alt="icono Trello" width="40" />
                        </li>
                        <li>
                            <img src={iconClickup} alt="icono ClickUp" width="40" />
                        </li>
                        <li>
                            <img src={iconGsuite} alt="icono GSuite" width="40" />
                        </li>
                    </ul>
                </div>
            </section>
        </article>
    );
}

export default Resume;
